import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);
        this.stateDescription = {
            battery_low: this.gettext('battery_low'),
            monitor_alarm: this.gettext('monitor_mode'),
            silent: this.gettext('silent_mode'),
            tamper_alarm: this.gettext('tamper_alarm'),
            tamper_open: this.gettext('tamper_open'),
            ready: this.gettext('ready'),
        };
        this.stateList = [this.gettext('battery_low'), this.gettext('monitor_alarm'), this.gettext('silent'), this.gettext('tamper_alarm')];
        this.CONNECTION_TEXT = [this.gettext('Turn on'), this.gettext('Turn off')];
        this._statisticGraphChartBindToName = 'doorLockChart';
        this.doorLocks = null;
        this.$scope.currentPromise = this.getDoorLocks();
        // todo: implement specific doorLock tamper ws event
        this.newReportEventReference = this.$rootScope.$on('newReport', (e, event) => {

            if (event.hasOwnProperty('data')) {
                if (event.data.hasOwnProperty('text')) {
                    if (_.includes(event.data.text.toLowerCase(), 'doorLock')) {
                        this.getDoorLocks();
                        this.$scope.$apply();
                    }
                }
            }
        });

        this.tamper = this.$rootScope.$on('tamper', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'tamper_alarm', 'Zone', this._findDoorLock.bind(this)); //todo: check why Zone instead of DoorLock
        });

        this.socketEventReference = this.$rootScope.$on('socketEvent', (e, event) => {
            this.getDoorLocks();
        });

        this.$element.on('$destroy', () => {

            this.closeModal('AcPlugStatisticsModal');
            this.closeModal('doorLockGraphModal');
            this.closeModal('GenericStatisticsModal');
            this.newReportEventReference();
            this.tamper();
            this.socketEventReference();
        });

    }

    _findDoorLock(doorLockId) {
        return _.find(this.doorLocks, {'id': doorLockId})
    }

    getDeviceDescription(id) {
        let deviceType = this.DEVICE_TYPE[id];
        if (deviceType) {
            return deviceType.deviceTypeDescription;
        } else {
            return 'Unknown device type';
        }
    }

    getDoorLocks() {

        return super.getDoorLocks()
            .then(resp => {
                this.doorLocks = resp.data;
            })
            .catch(() => {
            });

    }

    toggleDoorLock(doorLock) {
        this.$scope.currentPromise = super.setDoorLock(this.panelId, doorLock.id, !doorLock.locked)
            .then(resp => {
                doorLock.locked = resp.data.locked;
            });

    }

    getState(doorLock) {

        let stateList = '';
        let openText = null;

        for (let stateOption of this.stateList) {
            if (stateOption == 'state' && doorLock[stateOption] == true) {
                openText = this.getTranslatableText('Open');
            }
            if (doorLock[stateOption] == true) {
                stateList += this.$filter('humanize')(this.getTranslatableText(stateOption)) + ', ';
            }
        }

        if (openText) {
            stateList = openText + ', ' + stateList;
        }

        return stateList.slice(0, -2);
    }

    loadChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('doorLockGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getDectDoorLockMeasurements);
    }

    loadGenericStatisticsChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('doorLockGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getDoorLockGenericStatisticsMeasurements);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/doorLocks.component/controller.js
 **/